const HospitalityUsagePicturesSection = () => {
    return (
        <section className="basic-area" style={{ backgroundColor: "#f8f9fa" }}>
            <div className="container">
                <h2 style={{textAlign:"center"}}>
                    See Katalife in Action
                </h2>
                <div className="hospitality-photos-carousel">
                    <div className="hospitality-photos-track">
                        <div className="hospitality-photo-item">
                            <img src="/images/photos/hospitality/cafe-qrcode-table.png" alt="Cafe QR Code on Table" />
                        </div>
                        <div className="hospitality-photo-item">
                            <img src="/images/photos/hospitality/catering-qrcode-example.png" alt="Catering QR Code Example" />
                        </div>
                        {/* Duplicate for seamless loop */}
                        <div className="hospitality-photo-item">
                            <img src="/images/photos/hospitality/cafe-qrcode-table.png" alt="Cafe QR Code on Table" />
                        </div>
                        <div className="hospitality-photo-item">
                            <img src="/images/photos/hospitality/catering-qrcode-example.png" alt="Catering QR Code Example" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HospitalityUsagePicturesSection;
